// extracted by mini-css-extract-plugin
export var connectionButton = "_bp-1";
export var connectionButtonFloating = "_bp-2";
export var connectionContainer = "_bp-0";
export var rightPanel = "_bp-6";
export var stepCard = "_bp-3";
export var stepCardSubtitle = "_bp-5";
export var stepCardText = "_bp-4";